module.exports = __webpack_public_path__ + "static/media/restaurant-8.1e57fa50.jpg";